<app-loader [class.d-none]="!showLoader"></app-loader>
<router-outlet>
</router-outlet>
